import React from "react";
import { Card, FormLayout, TextField, Select } from "@shopify/polaris";
import PropTypes from "prop-types";
import constant from "lib/constant/constant";

const Inventory = (props) => {
  const { data, onChange, cms } = props;
  const { sku, barCode, inventoryPolicy, quantity } = data;
  const isDontTrackPolicy = inventoryPolicy !== "shopify";

  const handleInventory = (key, value) => {
    onChange((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleInventoryPolicy = (value) => {
    if (value === constant.DO_NOT_TRACK_INVENTORY) {
      handleInventory(constant.QUANTITY, "");
    }
    handleInventory(constant.INVENTORY_POLICY, value);
  };

  return (
    <Card sectioned title={cms("section.inventory.title")}>
      <FormLayout>
        <TextField
          id="sku"
          label={cms("section.inventory.label.sku")}
          value={sku}
          onChange={(value) => handleInventory(constant.SKU, value)}
          placeholder={cms("section.inventory.placeholder.zero")}
        />
        <TextField
          id="barCode"
          label={cms("section.inventory.label.barcode")}
          value={barCode}
          onChange={(value) => handleInventory(constant.BARCODE_CAMEL, value)}
          placeholder={cms("section.inventory.placeholder.zero")}
        />
        <Select
          id="inventoryPolicy"
          label={cms("section.inventory.label.inventoryPolicy")}
          options={[
            { label: cms("section.inventory.label.notTrack"), value: constant.DO_NOT_TRACK_INVENTORY },
            { label: cms("section.inventory.label.shopify"), value: constant.SHOPIFY },
          ]}
          onChange={handleInventoryPolicy}
          value={inventoryPolicy}
        />
        {inventoryPolicy === constant.SHOPIFY ? (
          <TextField
            id="inventoryQuantity"
            label={cms("section.inventory.label.quantity")}
            value={quantity}
            onChange={(value) => handleInventory(constant.QUANTITY, value)}
            placeholder={cms("section.inventory.placeholder.zero")}
            disabled={isDontTrackPolicy}
          />
        ) : (
          ""
        )}
      </FormLayout>
    </Card>
  );
};

Inventory.propTypes = {
  cms: PropTypes.func.isRequired,
  data: PropTypes.objectOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Inventory;
